import { Universe, UniverseYear } from "models/universes"

import { http } from "./http"

export const fetchUniverseYears = async (_key: string) => {
  const { data } = await http.get(`universes`).json<{ data: UniverseYear[] }>()
  return data
}

export const createUniverseYear = async (pld: Partial<UniverseYear>) => {
  const res = await http
    .post(`universes`, {
      json: pld,
    })
    .json()
  return res as UniverseYear
}

export const deleteUniverseYear = async (universeId: string) => {
  await http.delete(`universes/${universeId}`)
}

export const fetchUniverseRecords = async (_key: string, id: string) => {
  const { data } = await http
    .get(`universes/${id}`)
    .json<{ data: Universe[] }>()
  return data
}

export const createUniverseRecord = async (
  pld: Partial<Universe> & { universeId: string },
) => {
  const { universeId, ...data } = pld
  const res = await http
    .post(`universes/${universeId}/records`, {
      json: data,
    })
    .json()
  return res as Universe
}

export const updateRecordPopulation = async (
  payload: { population: number } & { recordId: string },
) => {
  const { recordId, ...json } = payload
  const res = await http.patch(`universes/records/${recordId}`, { json }).json()
  return res as Universe
}

export const deleteUniverseRecord = async ({
  universeId,
}: {
  universeId: string
}) => {
  await http.delete(`universes/records/${universeId}`)
}
